import "core-js/modules/es.array.map";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./homepage-brand-value.css";
export function JoinItem(_ref) {
  var paragraph = _ref.paragraph,
      joinUrl = _ref.joinUrl;
  return React.createElement("div", {
    className: styles.joinItem
  }, React.createElement("p", {
    className: styles.joinParagraph
  }, paragraph), React.createElement("a", {
    href: joinUrl,
    className: styles.joinUrl
  }, gettext("homepage.module_value_props_join_button") // Join
  , React.createElement(SVGIcon, {
    className: styles.arrowIcon,
    name: "arrow-icon"
  })));
}
export function HomepageBrandValueItem(_ref2) {
  var value = _ref2.value,
      numeral = _ref2.numeral;
  return React.createElement("li", {
    className: styles.homepageBrandValueItem
  }, React.createElement("h2", {
    className: styles.numeral
  }, " ", numeral, " "), React.createElement("h4", {
    className: styles.title
  }, " ", value.title, " "), value.paragraphs.map(function (paragraph) {
    return React.createElement("p", {
      key: paragraph,
      className: styles.paragraph
    }, paragraph);
  }));
}

function HomepageBrandValue(_ref3) {
  var items = _ref3.items,
      joinParagraph = _ref3.join_paragraph,
      joinUrl = _ref3.join_url;
  return React.createElement("div", {
    className: styles.homepageBrandValueWrapper
  }, React.createElement("div", {
    className: styles.valuesContainer
  }, React.createElement("ul", {
    className: styles.homepageBrandValuesList
  }, items.map(function (value, index) {
    return React.createElement(HomepageBrandValueItem, {
      key: value.title,
      value: value,
      numeral: index + 1
    });
  }))), React.createElement("div", {
    className: styles.actionContainer
  }, React.createElement(JoinItem, {
    paragraph: joinParagraph,
    joinUrl: joinUrl
  })));
}

export default HomepageBrandValue;